import { loadAlpineAsync } from '@/src/utilities/script-loader';

export function load() {
  /**
   * In Page Builder 'Edit' mode, the Related Videos Widgets
   * are rendered asynchronously, so we cannot rely on them being
   * in the DOM by the time these scrips run.
   *
   * So we delay loading anything until they exist.
   *
   * Note: Currently this code only handles 1 set of Accordion/Embed Widgets
   * per page
   */

  if (!window.wvXperience) {
    return;
  }

  window.wvXperience.registerComponentOnLoad(
    'related-videos-accordion',
    async (_module) => {
      const Alpine = await loadAlpineAsync();

      Alpine.store('relatedVideos', {
        selectedVideoId: '',
        videos: [],
        handleOnClick(/** @type {string} */ videoId) {
          if (this.selectedVideoId === videoId) {
            return;
          }

          this.selectedVideoId = videoId;
        },
        isSelected(/** @type {string} */ videoId) {
          return this.selectedVideoId === videoId;
        },
      });

      Alpine.data('video', (id) => ({
        id,
        init,
      }));

      Alpine.start();

      /** @this {AlpineContext} */
      function init() {
        const store = Alpine.store('relatedVideos');

        store.videos.push({
          id: this.id,
          html: this.$refs.embed.innerHTML,
        });

        if (store.selectedVideoId) {
          return;
        }

        /**
         * Set the selected video to the first initialized
         */
        store.selectedVideoId = this.id;
      }
    },
  );
}
